const M = (o, c, a, i) => {
  const { selection: u } = c, { from: h, to: f } = u, l = [];
  return c.doc.nodesBetween(h, f, (t, s) => {
    t.isText && t.marks.forEach((e) => {
      e.type.name === "textStyle" && e.attrs[o] && l.push({ mark: e, pos: s, size: t.nodeSize });
    });
  }), l.forEach(({ mark: t, pos: s, size: e }) => {
    const m = { ...t.attrs, [o]: null }, x = Math.max(h, s), k = Math.min(f, s + e);
    if (a.removeMark(x, k, t.type), Object.entries(m).some(
      ([n, r]) => n !== o && r !== null && r !== void 0
    )) {
      const n = c.schema.marks.textStyle;
      if (n) {
        const r = n.create(m);
        a.addMark(x, k, r);
      }
    }
  }), i && i(a), !0;
};
export {
  M as unsetTextStyleAttribute
};
